import { useState, useEffect } from 'react';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import { Link } from 'react-router-dom';
import ProcessPricingSection from '@/pages/services/components/ProcessPricingSection';

const SITE_URL = import.meta.env.VITE_SITE_URL || 'https://example.com';

const services = [
  {
    title: '아파트 인테리어',
    price: '평당 120만원~',
    icon: 'ri-building-2-line',
    img: 'https://public.readdy.ai/ai/img_res/b045fd71af8fa03bbd96ff84d5b484f2.jpg',
    features: ['전체 철거 및 재시공', '맞춤형 붙박이장 제작', '욕실/주방 리모델링', '바닥재/도배 전체 교체', '조명 설계 및 시공', '2년 A/S 보증'],
    desc: '강남 아파트 전문 시공팀이 평당 최적화된 설계로 넓고 쾌적한 주거 공간을 완성합니다. 30년 노하우로 자재 선택부터 마감까지 완벽하게 책임집니다.',
  },
  {
    title: '빌라 인테리어',
    price: '평당 100만원~',
    icon: 'ri-home-4-line',
    img: 'https://readdy.ai/api/search-image?query=stylish%20Korean%20villa%20interior%20design%20completed%20cozy%20living%20space%20warm%20wood%20tones%20modern%20kitchen%20tasteful%20decoration%20comfortable%20elegant%20atmosphere%20renovation&width=800&height=500&seq=svcfull002&orientation=landscape',
    features: ['구조 변경 가능', '개성 있는 맞춤 설계', '주방/욕실 전면 교체', '단열/방음 공사', '전기/배관 전면 교체', '2년 A/S 보증'],
    desc: '개성 있는 빌라 공간을 감각적인 디자인으로 변신시킵니다. 구조 변경부터 마감재 선택까지 고객의 라이프스타일에 맞는 최적의 공간을 제안합니다.',
  },
  {
    title: '오피스텔 인테리어',
    price: '평당 90만원~',
    icon: 'ri-hotel-line',
    img: 'https://readdy.ai/api/search-image?query=compact%20modern%20Korean%20officetel%20interior%20design%20smart%20space%20utilization%20built-in%20furniture%20clean%20minimalist%20style%20functional%20stylish%20small%20apartment%20renovation%20completed&width=800&height=500&seq=svcfull003&orientation=landscape',
    features: ['공간 효율 극대화 설계', '빌트인 가구 제작', '원룸/투룸 전문', '스마트홈 시스템 연동', '수납 공간 최적화', '2년 A/S 보증'],
    desc: '작은 공간도 효율적으로 활용하는 스마트한 설계를 제공합니다. 오피스텔 특성에 맞는 빌트인 가구와 수납 솔루션으로 쾌적한 생활 공간을 만들어 드립니다.',
  },
  {
    title: '상업공간 인테리어',
    price: '별도 문의',
    icon: 'ri-store-2-line',
    img: 'https://readdy.ai/api/search-image?query=upscale%20Korean%20commercial%20interior%20design%20modern%20cafe%20restaurant%20space%20sophisticated%20brand%20identity%20warm%20lighting%20premium%20materials%20inviting%20atmosphere%20renovation%20completed&width=800&height=500&seq=svcfull004&orientation=landscape',
    features: ['브랜드 아이덴티티 반영', '카페/레스토랑 전문', '사무실/쇼룸 시공', '인허가 대행 서비스', '간판/사인물 제작', '사후 관리 서비스'],
    desc: '브랜드 아이덴티티를 살린 매력적인 상업 공간을 만들어 드립니다. 카페, 레스토랑, 사무실, 쇼룸 등 다양한 상업공간 시공 경험을 보유하고 있습니다.',
  },
  {
    title: '사무실 인테리어',
    price: '평당 80만원~',
    icon: 'ri-briefcase-line',
    img: 'https://readdy.ai/api/search-image?query=modern%20Korean%20office%20interior%20design%20completed%2C%20professional%20workspace%20with%20ergonomic%20furniture%2C%20clean%20minimalist%20design%2C%20good%20lighting%2C%20productive%20atmosphere%2C%20Seoul%20corporate%20office&width=800&height=500&seq=svcfull005&orientation=landscape',
    features: ['업무 효율 중심 설계', '파티션/가구 배치', '회의실/임원실 전문', '전기/통신 배선', '방음 공사', '유지보수 계약'],
    desc: '업무 효율을 높이는 쾌적한 사무 환경을 만들어 드립니다. 직원 동선과 업무 특성을 분석하여 최적의 오피스 레이아웃을 설계합니다.',
  },
  {
    title: '카페 & 레스토랑',
    price: '별도 문의',
    icon: 'ri-cup-line',
    img: 'https://readdy.ai/api/search-image?query=trendy%20Korean%20cafe%20interior%20renovation%20completed%2C%20warm%20wood%20tones%20industrial%20chic%20design%20cozy%20seating%20areas%20pendant%20lighting%20modern%20coffee%20shop%20atmosphere%20Gangnam&width=800&height=500&seq=svcfull006&orientation=landscape',
    features: ['F&B 전문 설계팀', '주방 동선 최적화', '인테리어 + 주방기기', '소방/위생 허가 대행', '테라스/외부 공사', '오픈 후 A/S'],
    desc: '고객이 머물고 싶은 매력적인 F&B 공간을 만들어 드립니다. 주방 동선부터 홀 인테리어까지 운영 효율을 고려한 전문적인 설계를 제공합니다.',
  },
];

const roomServices = [
  {
    id: 'living',
    title: '거실 인테리어',
    icon: 'ri-sofa-line',
    price: '300만원~',
    tag: '가장 인기',
    img: 'https://readdy.ai/api/search-image?query=luxurious%20modern%20Korean%20living%20room%20interior%20renovation%20completed%2C%20elegant%20sofa%20arrangement%2C%20feature%20wall%20with%20indirect%20lighting%2C%20premium%20flooring%2C%20minimalist%20decor%2C%20warm%20neutral%20tones%2C%20spacious%20bright%20atmosphere%2C%20Gangnam%20apartment&width=800&height=560&seq=room001&orientation=landscape',
    desc: '가족이 함께하는 거실을 감각적이고 편안한 공간으로 탈바꿈합니다. 포인트 월, 간접 조명, 맞춤 수납장으로 넓고 세련된 거실을 완성합니다.',
    features: ['포인트 월 & 아트월 시공', '간접 조명 설계', '맞춤 TV장 & 수납장 제작', '바닥재 교체 (마루/타일)', '도배 & 몰딩 시공', '커튼 & 블라인드 설치'],
    color: 'from-amber-50 to-orange-50',
  },
  {
    id: 'kitchen',
    title: '주방 인테리어',
    icon: 'ri-knife-line',
    price: '400만원~',
    tag: '전문 시공',
    img: 'https://readdy.ai/api/search-image?query=sleek%20modern%20Korean%20kitchen%20interior%20renovation%20completed%2C%20custom%20cabinetry%20white%20and%20wood%20tones%2C%20island%20counter%2C%20premium%20appliances%2C%20pendant%20lighting%2C%20clean%20minimalist%20design%2C%20functional%20elegant%20cooking%20space&width=800&height=560&seq=room002&orientation=landscape',
    desc: '요리가 즐거워지는 기능적이고 아름다운 주방을 만들어 드립니다. 맞춤 제작 싱크대와 수납 시스템으로 효율적인 주방 동선을 설계합니다.',
    features: ['맞춤 싱크대 & 상부장 제작', '아일랜드 & 식탁 연계 설계', '타일 & 벽면 마감', '빌트인 가전 설치', '후드 & 환기 시스템', '수전 & 배관 교체'],
    color: 'from-stone-50 to-amber-50',
  },
  {
    id: 'bedroom',
    title: '침실 인테리어',
    icon: 'ri-hotel-bed-line',
    price: '200만원~',
    tag: '편안한 휴식',
    img: 'https://readdy.ai/api/search-image?query=serene%20elegant%20Korean%20master%20bedroom%20interior%20renovation%20completed%2C%20upholstered%20headboard%2C%20soft%20neutral%20palette%2C%20layered%20lighting%2C%20built-in%20wardrobe%2C%20cozy%20luxurious%20atmosphere%2C%20premium%20bedding%2C%20calm%20sophisticated%20design&width=800&height=560&seq=room003&orientation=landscape',
    desc: '하루의 피로를 풀어주는 편안하고 아늑한 침실 공간을 완성합니다. 수면 환경에 최적화된 조명과 수납 설계로 진정한 휴식 공간을 만들어 드립니다.',
    features: ['맞춤 헤드보드 & 침대 프레임', '붙박이장 & 수납 설계', '간접 조명 & 무드 조명', '방음 & 단열 공사', '도배 & 바닥재 교체', '암막 커튼 설치'],
    color: 'from-blue-50 to-indigo-50',
  },
  {
    id: 'bathroom',
    title: '화장실 인테리어',
    icon: 'ri-drop-line',
    price: '250만원~',
    tag: '완전 리모델링',
    img: 'https://readdy.ai/api/search-image?query=luxurious%20modern%20Korean%20bathroom%20renovation%20completed%2C%20large%20format%20marble%20tiles%2C%20freestanding%20bathtub%2C%20frameless%20glass%20shower%2C%20premium%20fixtures%2C%20warm%20lighting%2C%20spa-like%20atmosphere%2C%20clean%20sophisticated%20design&width=800&height=560&seq=room004&orientation=landscape',
    desc: '매일 사용하는 화장실을 호텔 수준의 럭셔리한 공간으로 업그레이드합니다. 방수 공사부터 타일, 위생도기까지 완벽한 화장실 리모델링을 제공합니다.',
    features: ['방수 공사 & 타일 시공', '위생도기 & 수전 교체', '욕조 & 샤워부스 설치', '세면대 & 거울장 제작', '환기 & 난방 시스템', '수납 선반 & 악세서리'],
    color: 'from-cyan-50 to-teal-50',
  },
  {
    id: 'dressroom',
    title: '드레스룸 인테리어',
    icon: 'ri-shirt-line',
    price: '350만원~',
    tag: '맞춤 제작',
    img: 'https://readdy.ai/api/search-image?query=elegant%20custom%20walk-in%20closet%20dressing%20room%20interior%20renovation%20completed%2C%20organized%20wardrobe%20system%2C%20full%20length%20mirror%2C%20soft%20lighting%2C%20white%20and%20wood%20tones%2C%20luxury%20boutique%20feel%2C%20premium%20storage%20solutions&width=800&height=560&seq=room005&orientation=landscape',
    desc: '옷과 소품을 체계적으로 정리할 수 있는 나만의 드레스룸을 완성합니다. 의류 종류와 수납량에 맞춘 맞춤 설계로 효율적인 드레스룸을 만들어 드립니다.',
    features: ['맞춤 행거 & 선반 시스템', '전신 거울 & 조명 설계', '서랍장 & 수납함 제작', '슬라이딩 도어 설치', '조명 연출 (LED 간접등)', '바닥재 & 도배 마감'],
    color: 'from-rose-50 to-pink-50',
  },
  {
    id: 'alpharoom',
    title: '알파룸 인테리어',
    icon: 'ri-layout-masonry-line',
    price: '150만원~',
    tag: '공간 활용',
    img: 'https://readdy.ai/api/search-image?query=creative%20multipurpose%20small%20room%20interior%20renovation%20completed%2C%20home%20office%20study%20nook%2C%20built-in%20desk%20and%20shelving%2C%20smart%20storage%20solutions%2C%20cozy%20productive%20atmosphere%2C%20modern%20minimalist%20design%2C%20efficient%20use%20of%20space&width=800&height=560&seq=room006&orientation=landscape',
    desc: '애매한 공간을 나만의 서재, 홈오피스, 취미실로 완성합니다. 공간의 특성을 살린 맞춤 설계로 활용도 높은 알파룸을 만들어 드립니다.',
    features: ['맞춤 책상 & 선반 제작', '홈오피스 & 서재 설계', '취미실 & 놀이방 변환', '수납 최적화 설계', '조명 & 콘센트 배치', '방음 & 단열 처리'],
    color: 'from-green-50 to-emerald-50',
  },
  {
    id: 'utility',
    title: '다용도실 인테리어',
    icon: 'ri-tools-line',
    price: '120만원~',
    tag: '실용 공간',
    img: 'https://readdy.ai/api/search-image?query=modern%20Korean%20utility%20laundry%20room%20renovation%20completed%2C%20built-in%20washing%20machine%20dryer%20cabinet%2C%20organized%20storage%20shelves%2C%20clean%20white%20and%20light%20gray%20tones%2C%20functional%20practical%20space%2C%20neat%20tidy%20design%2C%20efficient%20layout%2C%20bright%20lighting&width=800&height=560&seq=room008&orientation=landscape',
    desc: '세탁, 청소, 수납을 한 번에 해결하는 효율적인 다용도실을 만들어 드립니다. 좁은 공간도 체계적인 수납 설계와 빌트인 가전 배치로 최대한 활용합니다.',
    features: ['세탁기 & 건조기 빌트인 설치', '맞춤 수납장 & 선반 제작', '방수 & 타일 바닥 시공', '싱크대 & 수전 설치', '환기 & 배관 공사', '청소 도구 수납 설계'],
    color: 'from-slate-50 to-gray-50',
  },
  {
    id: 'veranda',
    title: '베란다 인테리어',
    icon: 'ri-plant-line',
    price: '180만원~',
    tag: '확장 & 활용',
    img: 'https://readdy.ai/api/search-image?query=beautiful%20Korean%20apartment%20veranda%20balcony%20renovation%20completed%2C%20extended%20living%20space%2C%20indoor%20garden%20plants%2C%20cozy%20seating%20area%2C%20natural%20light%2C%20wood%20deck%20flooring%2C%20modern%20minimalist%20design%2C%20relaxing%20outdoor%20feel&width=800&height=560&seq=room007&orientation=landscape',
    desc: '방치된 베란다를 힐링 공간으로 탈바꿈합니다. 확장 공사부터 가든 조성까지 생활 공간을 넓히고 삶의 질을 높이는 베란다 인테리어를 제공합니다.',
    features: ['베란다 확장 공사', '방수 & 단열 시공', '데크 & 타일 바닥 시공', '인도어 가든 조성', '수납 & 세탁 공간 설계', '창호 & 샷시 교체'],
    color: 'from-lime-50 to-green-50',
  },
];

export default function ServicesPage() {
  const [activeRoom, setActiveRoom] = useState('living');
  const currentRoom = roomServices.find((r) => r.id === activeRoom) || roomServices[0];

  useEffect(() => {
    document.title = '시공 서비스 | 필그린 인테리어 강남 아파트·빌라·상업공간';
    const setMeta = (name: string, content: string, prop = false) => {
      const attr = prop ? 'property' : 'name';
      let el = document.querySelector(`meta[${attr}="${name}"]`) as HTMLMetaElement | null;
      if (!el) { el = document.createElement('meta'); el.setAttribute(attr, name); document.head.appendChild(el); }
      el.content = content;
    };
    setMeta('description', '필그린 인테리어 시공 서비스. 아파트(평당 120만원~), 빌라, 오피스텔, 상업공간, 사무실, 카페·레스토랑 전문 시공. 강남 30년 노하우.');
    setMeta('og:title', '시공 서비스 | 필그린 인테리어 강남 아파트·빌라·상업공간', true);
    setMeta('og:url', `${SITE_URL}/services`, true);

    const jsonLd = {
      '@context': 'https://schema.org',
      '@type': 'Service',
      name: '필그린 인테리어 시공 서비스',
      provider: {
        '@type': 'LocalBusiness',
        name: '필그린 인테리어',
        url: SITE_URL,
        telephone: '010-5350-7926',
        address: {
          '@type': 'PostalAddress',
          streetAddress: '양재대로55길6 종합상가 203호',
          addressLocality: '강남구',
          addressRegion: '서울특별시',
          addressCountry: 'KR',
        },
      },
      areaServed: '서울특별시 강남구',
      hasOfferCatalog: {
        '@type': 'OfferCatalog',
        name: '인테리어 시공 서비스',
        itemListElement: [
          { '@type': 'Offer', itemOffered: { '@type': 'Service', name: '아파트 인테리어', description: '평당 120만원~' } },
          { '@type': 'Offer', itemOffered: { '@type': 'Service', name: '빌라 인테리어', description: '평당 100만원~' } },
          { '@type': 'Offer', itemOffered: { '@type': 'Service', name: '오피스텔 인테리어', description: '평당 90만원~' } },
          { '@type': 'Offer', itemOffered: { '@type': 'Service', name: '상업공간 인테리어', description: '별도 문의' } },
          { '@type': 'Offer', itemOffered: { '@type': 'Service', name: '사무실 인테리어', description: '평당 80만원~' } },
          { '@type': 'Offer', itemOffered: { '@type': 'Service', name: '카페 & 레스토랑 인테리어', description: '별도 문의' } },
        ],
      },
      url: `${SITE_URL}/services`,
    };

    const scriptId = 'jsonld-services';
    let script = document.getElementById(scriptId) as HTMLScriptElement | null;
    if (!script) { script = document.createElement('script'); script.id = scriptId; script.type = 'application/ld+json'; document.head.appendChild(script); }
    script.textContent = JSON.stringify(jsonLd);
    return () => { document.getElementById(scriptId)?.remove(); };
  }, []);

  return (
    <div className="bg-[#f7f5f3] min-h-screen">
      <Navbar />
      {/* Hero */}
      <section className="relative h-72 md:h-96 flex items-end overflow-hidden">
        <div className="absolute inset-0">
          <img
            src="https://readdy.ai/api/search-image?query=interior%20design%20tools%20and%20materials%20on%20elegant%20dark%20surface%2C%20architectural%20blueprints%2C%20material%20samples%2C%20professional%20design%20studio%20atmosphere%2C%20premium%20quality&width=1920&height=600&seq=svchero&orientation=landscape"
            alt="서비스 배경"
            className="w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-black/40" />
        </div>
        <div className="relative z-10 max-w-[1400px] mx-auto px-6 md:px-12 pb-12 w-full">
          <span className="text-[#c9a84c] text-xs tracking-[0.3em] uppercase font-medium">Services</span>
          <h1 className="text-3xl md:text-5xl font-light text-white mt-2 leading-snug md:leading-tight" style={{ fontFamily: "'Noto Serif KR', serif" }}>시공 서비스</h1>
        </div>
      </section>

      {/* Services List */}
      <section className="max-w-[1400px] mx-auto px-6 md:px-12 py-20">
        <div className="space-y-16">
          {services.map((svc, i) => (
            <div key={svc.title} className={`grid grid-cols-1 lg:grid-cols-2 gap-10 items-center ${i % 2 === 1 ? 'lg:flex-row-reverse' : ''}`}>
              <div className={`${i % 2 === 1 ? 'lg:order-2' : ''}`}>
                <div className="w-full h-72 rounded-2xl overflow-hidden">
                  <img src={svc.img} alt={svc.title} className="w-full h-full object-cover object-top" />
                </div>
              </div>
              <div className={`${i % 2 === 1 ? 'lg:order-1' : ''}`}>
                <div className="flex items-center gap-3 mb-4">
                  <div className="w-10 h-10 flex items-center justify-center rounded-xl bg-[#c9a84c]/10">
                    <i className={`${svc.icon} text-[#c9a84c] text-lg`} />
                  </div>
                  <span className="bg-[#c9a84c] text-[#0d0d0d] text-xs font-bold px-3 py-1.5 rounded-full">{svc.price}</span>
                </div>
                <h2 className="text-2xl md:text-3xl font-semibold text-[#1a1a1a] mb-3 md:mb-4 leading-snug" style={{ fontFamily: "'Noto Serif KR', serif" }}>{svc.title}</h2>
                <p className="text-[#555] text-sm leading-relaxed mb-6 break-keep">{svc.desc}</p>
                <div className="grid grid-cols-2 gap-2 mb-8">
                  {svc.features.map((f) => (
                    <div key={f} className="flex items-center gap-2 text-sm text-[#333] whitespace-nowrap overflow-hidden">
                      <i className="ri-check-line text-[#c9a84c] shrink-0" />
                      <span className="truncate">{f}</span>
                    </div>
                  ))}
                </div>
                <Link to="/estimate" className="inline-flex items-center gap-2 bg-[#c9a84c] text-[#0d0d0d] font-bold text-sm px-7 py-3 rounded-full whitespace-nowrap cursor-pointer hover:bg-[#b8973b] transition-colors">
                  견적 문의하기 <i className="ri-arrow-right-line" />
                </Link>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* ─── 공정별 상세 설명 & 가격 섹션 ─── */}
      <ProcessPricingSection />

      {/* ─── 공간별 세부 인테리어 섹션 ─── */}
      <section className="bg-white py-24">
        <div className="max-w-[1400px] mx-auto px-6 md:px-12">
          {/* 섹션 헤더 */}
          <div className="text-center mb-14">
            <span className="text-[#c9a84c] text-xs tracking-[0.3em] uppercase font-medium">Space by Space</span>
            <h2 className="text-2xl md:text-4xl font-semibold text-[#1a1a1a] mt-3 mb-4 leading-snug" style={{ fontFamily: "'Noto Serif KR', serif" }}>
              공간별 세부 인테리어
            </h2>
            <p className="text-[#666] text-sm max-w-xl mx-auto leading-relaxed">
              거실부터 베란다까지, 집 안의 모든 공간을 전문적으로 시공합니다.<br />
              feel green의 노하우로 각 공간의 특성에 맞는 최적의 인테리어를 제안합니다.
            </p>
          </div>

          {/* 탭 버튼 */}
          <div className="flex flex-wrap justify-center gap-2 mb-12">
            {roomServices.map((room) => (
              <button
                key={room.id}
                onClick={() => setActiveRoom(room.id)}
                className={`flex items-center gap-2 px-5 py-2.5 rounded-full text-sm font-medium transition-all duration-200 whitespace-nowrap cursor-pointer ${
                  activeRoom === room.id
                    ? 'bg-[#c9a84c] text-[#0d0d0d]'
                    : 'bg-[#f4f1eb] text-[#555] hover:bg-[#ede9df]'
                }`}
              >
                <div className="w-4 h-4 flex items-center justify-center">
                  <i className={`${room.icon} text-sm`} />
                </div>
                {room.title.replace(' 인테리어', '')}
              </button>
            ))}
          </div>

          {/* 선택된 공간 상세 */}
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            {/* 이미지 */}
            <div className="relative">
              <div className="w-full h-[420px] rounded-2xl overflow-hidden">
                <img
                  key={currentRoom.id}
                  src={currentRoom.img}
                  alt={currentRoom.title}
                  className="w-full h-full object-cover object-top transition-opacity duration-300"
                />
              </div>
            </div>

            {/* 내용 */}
            <div>
              <div className="flex items-center gap-3 mb-5">
                <div className="w-12 h-12 flex items-center justify-center rounded-2xl bg-[#c9a84c]/10">
                  <i className={`${currentRoom.icon} text-[#c9a84c] text-xl`} />
                </div>
                <div>
                  <h3 className="text-xl md:text-3xl font-semibold text-[#1a1a1a] leading-snug" style={{ fontFamily: "'Noto Serif KR', serif" }}>
                    {currentRoom.title}
                  </h3>
                  <span className="text-[#c9a84c] text-sm font-bold">{currentRoom.price}</span>
                </div>
              </div>

              <p className="text-[#555] text-sm leading-relaxed mb-8">{currentRoom.desc}</p>

              <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 mb-10">
                {currentRoom.features.map((f) => (
                  <div key={f} className="flex items-center gap-2.5 bg-[#f8f6f1] rounded-xl px-4 py-3">
                    <div className="w-5 h-5 flex items-center justify-center">
                      <i className="ri-check-line text-[#c9a84c] text-base" />
                    </div>
                    <span className="text-sm text-[#333]">{f}</span>
                  </div>
                ))}
              </div>

              <div className="flex flex-col sm:flex-row gap-3">
                <Link
                  to="/estimate"
                  className="inline-flex items-center justify-center gap-2 bg-[#c9a84c] text-[#0d0d0d] font-bold text-sm px-7 py-3.5 rounded-full whitespace-nowrap cursor-pointer hover:bg-[#b8973b] transition-colors"
                >
                  견적 문의하기 <i className="ri-arrow-right-line" />
                </Link>
                <Link
                  to="/consultation"
                  className="inline-flex items-center justify-center gap-2 border border-[#c9a84c] text-[#c9a84c] font-bold text-sm px-7 py-3.5 rounded-full whitespace-nowrap cursor-pointer hover:bg-[#c9a84c]/5 transition-colors"
                >
                  무료 상담 신청 <i className="ri-chat-1-line" />
                </Link>
              </div>
            </div>
          </div>

          {/* 하단 카드 그리드 */}
          <div className="mt-16 grid grid-cols-2 sm:grid-cols-4 lg:grid-cols-8 gap-3">
            {roomServices.map((room) => (
              <button
                key={room.id}
                onClick={() => setActiveRoom(room.id)}
                className={`group relative rounded-2xl overflow-hidden cursor-pointer transition-all duration-200 ${
                  activeRoom === room.id ? 'ring-2 ring-[#c9a84c]' : 'hover:ring-1 hover:ring-[#c9a84c]/50'
                }`}
              >
                <div className="w-full h-28 overflow-hidden">
                  <img
                    src={room.img}
                    alt={room.title}
                    className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-300"
                  />
                </div>
                <div className={`absolute inset-0 ${activeRoom === room.id ? 'bg-black/40' : 'bg-black/30 group-hover:bg-black/20'} transition-colors`} />
                <div className="absolute bottom-0 left-0 right-0 p-2 text-center">
                  <span className="text-white text-xs font-medium">{room.title.replace(' 인테리어', '')}</span>
                </div>
                {activeRoom === room.id && (
                  <div className="absolute top-2 right-2 w-5 h-5 flex items-center justify-center bg-[#c9a84c] rounded-full">
                    <i className="ri-check-line text-[#0d0d0d] text-xs" />
                  </div>
                )}
              </button>
            ))}
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
